export default function Marquee({ className = "" }) {
  const items = [
    "Social that bites back",
    "We are Hot Sauce",
    "Drop. Post. Repeat.",
    "Attention is the only currency",
    "Built in Pune",
    "Content that earns its place",
  ];

  return (
    <div
      className={`overflow-hidden bg-[#FF1111] text-white py-4 ${className}`}
      role="marquee"
      aria-label="Marquee banner"
    >
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center gap-0 shrink-0" aria-hidden={k > 0}>
            {items.map((item, i) => (
              <div key={i} className="flex items-center">
                <span className="font-display text-2xl md:text-3xl uppercase leading-none tracking-tight whitespace-nowrap px-6 md:px-10">
                  {item}
                </span>
                <span className="text-white/60 text-lg" aria-hidden="true">◆</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

